import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import assignees from "../components/argument-types/assignees";
import checklist from "@Shared/components/checklist/checklist";
import dropdown from "../components/dropdown";
import email from "../components/argument-types/email";
import emailReadonly from "../components/argument-types/email-readonly";
import multiOption from "../components/argument-types/multi-option";
import simpleBoldText from "../../../util-components/simple-bold-text";
import singleOption from "../components/argument-types/single-option";
import text from "../components/argument-types/text";
import textReadonly from "../components/argument-types/text-readonly";
import note from "../components/argument-types/note";
import noteReadonly from "../components/argument-types/note-readonly";
import time from "../components/argument-types/time";
import booleanInput from "../components/argument-types/boolean.vue";
import requestPackage from "../components/package";
const components = {
  "automation-checklist": checklist,
  "automation-email": email,
  "automation-multi-option": multiOption,
  "automation-single-option": singleOption,
  "automation-text": text,
  "automation-note": note,
  "automation-time": time,
  "bold-text": simpleBoldText,
  "automation-dropdown": dropdown,
  "automation-package": requestPackage,
  "automation-email-readonly": emailReadonly,
  "automation-assignees": assignees,
  "automation-assignees-single": assignees,
  "automation-note-readonly": noteReadonly,
  "automation-text-readonly": textReadonly,
  "automation-boolean": booleanInput
};
export const typeToUsableComponent = {
  components,
  methods: {
    typeToComponent(type, readOnly = false, action = null) {
      const map = {
        checklist: "automation-checklist",
        email: readOnly ? "automation-email-readonly" : "automation-email",
        "referrer-email": readOnly ? "automation-email-readonly" : "automation-email",
        "multi-option": readOnly ? "automation-dropdown" : "automation-multi-option",
        "single-option": "automation-dropdown",
        "package-option": "automation-package",
        text: "automation-text",
        note: "automation-note",
        assignees: "automation-assignees",
        "assignees-single": "automation-assignees-single",
        time: "automation-time",
        boolean: "automation-boolean"
      };
      if (type === "text" && action && action.key === "note") return map[action.key];
      return map[type];
    },
    actionToProps(action) {
      switch (action.type) {
        case "multi-option":
          return {
            items: _valuesInstanceProperty(action)
          };
        default:
          return null;
      }
    }
  }
};
export const typeToReadOnlyComponent = {
  components,
  methods: {
    typeToComponent(type, action) {
      var _context;
      const map = {
        checklist: "automation-checklist",
        email: "automation-email-readonly",
        "referrer-email": "automation-email-readonly",
        "multi-option": "bold-text",
        text: "bold-text",
        assignees: "automation-assignees",
        "assignees-single": "automation-assignees",
        "package-option": "automation-package",
        time: "bold-text",
        note: "automation-note-readonly",
        "follow-up": "automation-text-readonly",
        boolean: "automation-boolean"
      };
      const specialAction = _includesInstanceProperty(_context = ["note", "follow-up"]).call(_context, action && action.key);
      if (type === "text" && specialAction) return map[action.key];
      return map[type];
    }
  }
};